import { isTwitchEnabled } from '@util/const.js';
import CustomizeSection from '@components/overlays/shared/customize-section.jsx';
import CharityPicker from '@components/pickers/charity.picker.jsx';
import PropTypes from 'prop-types';

CharitySection.propTypes = {
  charityType: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function CharitySection({ charityType, onChange }) {
  if (isTwitchEnabled)
    return (
      <CustomizeSection title="Charity">
        <CharityPicker
          charityType={charityType}
          onChange={onChange}
        />
      </CustomizeSection>
    );
}
